import React, { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default function ReCaptcha({ resetRecaptcha, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    if (resetRecaptcha) {
      ref?.current?.reset();
    }
  }, [resetRecaptcha]);

  return <ReCAPTCHA {...props} hl="pt-BR" ref={ref} />;
}
